import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import { isClient } from '../is-client';
import { canIUseApi } from '../can-i-use-api';

const getUtmsFromUrl = ({ search } = {}) => {
  try {
    if (!search) return null;
    const params = new URLSearchParams(search);

    return Array.from(params.keys()).reduce(
      (acc, val) =>
        val?.toLowerCase()?.includes('utm') ? { ...acc, [val]: params.get(val) } : acc,
      {}
    );
  } catch (error) {
    return null;
  }
};

const getSessionIdFromLocalStorage = () => {
  if (!canIUseApi('sessionStorage')) return;

  return sessionStorage.getItem('support-center-session-id');
};

export const useAnalytics = () => {
  const ac = useContext(AnalyticsContext);

  return {
    trackEvent: (_eventName, _customAttributes, _overrides) => {
      try {
        if (!isClient()) return null;

        const { trackEvent } = ac || {};

        const data = {
          ..._customAttributes,
          ...Analytics.commonData(),
          previous_site: document.referrer,
          utm: getUtmsFromUrl(window.location),
          support_center_session_id: getSessionIdFromLocalStorage()
        };

        return trackEvent?.(_eventName, data, _overrides);
      } catch (error) {
        console.error('use analytics error', error);
        return null;
      }
    }
  };
};

export const Analytics = (() => {
  let _commonData = {};

  function setCommonData(data) {
    _commonData = data;
  }

  function commonData() {
    return _commonData;
  }

  return {
    setCommonData,
    commonData
  };
})();
